export default __webpack_public_path__ + "static/media/googleIcon.b3136124.png";